import * as React from "react";
import styled from "styled-components";
import PageContainer from "./pageContainer.js";
import {GatsbyImage} from "gatsby-plugin-image";
import Link from "./link.js";
import {when} from "../styles/theme.js";

const Container = styled.footer`
  background: ${(props) => props.theme.colors.darkBlue};
  color: ${(props) => props.theme.colors.white};
  padding-top: 8rem;
  padding-bottom: 3rem;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${when("md")} {
    flex-direction: row;
    align-items: flex-start;
  }
`;

const LogoOuterContainer = styled.div`
  ${when("md")} {
    flex: 1;
    align-items: flex-start;
  }
`;

const LogoContainer = styled.div`
  width: 20rem;
`;

const FooterLink = styled(Link)`
  display: block;
  padding: 2rem;
  font-size: 2rem;
`;

const PrimaryNav = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;

  ${when("md")} {
    flex: 1;
    align-items: flex-start;
    margin-top: -2rem;
    margin-left: -2rem;
  }
`;

const SecondaryNav = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${when("md")} {
    flex: 1;
    align-items: flex-start;
    margin-top: -2rem;
    margin-left: -2rem;
  }
`;

const Copyright = styled.div`
  text-align: center;
  font-size: 1.4rem;
  margin-top: 6rem;
`;

const Author = styled.small`
  margin-top: 3rem;
  text-align: center;
  display: block;
  font-size: 1rem;
`;

const Footer = ({footerNav, settings}) => {
  return (
    <Container>
      <PageContainer>
        <InnerContainer>
          {settings?.logo && (
            <LogoOuterContainer>
              <LogoContainer>
                <GatsbyImage
                  alt={settings.logo.description}
                  image={settings.logo.gatsbyImageData}
                />
              </LogoContainer>
            </LogoOuterContainer>
          )}
          <PrimaryNav>
            {footerNav?.primary?.links?.map((nav, index) => {
              return (
                <FooterLink href={nav.url} key={index}>
                  {nav.title}
                </FooterLink>
              );
            })}
          </PrimaryNav>
          <SecondaryNav>
            {footerNav?.secondary?.links?.map((nav, index) => {
              return (
                <FooterLink href={nav.url} key={index}>
                  {nav.title}
                </FooterLink>
              );
            })}
          </SecondaryNav>
        </InnerContainer>
        {settings?.copyright && <Copyright>{settings.copyright}</Copyright>}
        <Author>Designed & developed by: <a href={'https://www.sensiblelab.com/?utm_source=ajisen&utm_medium=referral&utm_campaign=client_website&utm_content=footer_link'} target={'_blank'}>Sensible
          Lab</a></Author>
      </PageContainer>
    </Container>
  );
};

export default Footer;
